import React from 'react';

import useFormFields from '../../../../../Form/CrudForm/hooks/useFormFields';

export default function OtherField({ field, formik }) {
  const fields = useFormFields([field], formik);
  return (
    <div>
      <div className="py-5">{fields}</div>
      <hr />
    </div>
  );
}
